module.exports = __webpack_public_path__ + "img/img-question-1-young-kids-writing-in-class-together.50b00eea.jpg";